import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../../../../../helpers/reselectHelpers';
import {LocalApplicationModel} from '../../../../../../models/api/localApplicationModel';
import {AppState} from '../../../../../../store/appState';
import {
  makeGetLocalApplicationsEntryPointAsyncStatus,
  makeGetLocalApplicationsInboxSidePanelEntryPoint,
} from '../../../../../../store/data/localApplications/localApplicationsSelectors';
import {DevelopersApplicationFeatureInboxSidePanelEntryPoint} from './developersApplicationFeatureInboxSidePanelEntryPoint';

/*
 * Props.
 */

interface DevelopersApplicationFeatureInboxSidePanelEntryPointContainerProps {
  application: LocalApplicationModel;
}

/*
 * Selectors.
 */

function getApplicationId(
  _state: AppState,
  props: DevelopersApplicationFeatureInboxSidePanelEntryPointContainerProps,
) {
  return props.application.id;
}

/*
 * Redux.
 */

const mapStateToProps =
  makeMapStateToProps<DevelopersApplicationFeatureInboxSidePanelEntryPointContainerProps>()(() => ({
    entryPoint: makeGetLocalApplicationsInboxSidePanelEntryPoint(getApplicationId),
    entryPointAsyncStatus: makeGetLocalApplicationsEntryPointAsyncStatus(getApplicationId),
  }));

export const DevelopersApplicationFeatureInboxSidePanelEntryPointContainer = connect(mapStateToProps)(
  DevelopersApplicationFeatureInboxSidePanelEntryPoint,
);
